class ReadMore extends HTMLElement {
  constructor () {
    super()

    this.containerEls = this.querySelectorAll('[data-el="read-more.container"]')

    this.initialiseReadMore()
  }

  initialiseReadMore () {
    this.containerEls.forEach(containerEl => {
      const triggerEl = containerEl.querySelector(
        '[data-el="read-more.trigger"]',
      )
      const excerptEl = containerEl.querySelector(
        '[data-el="read-more.excerpt"]',
      )

      containerEl.style.setProperty(
        '--Max_Height',
        `${excerptEl.offsetHeight}px`,
      )

      this.handleClick = this.handleClick.bind(this)

      triggerEl.addEventListener('click', this.handleClick)
    })
  }

  handleClick (event) {
    const currentState =
      event.target
        .closest('[data-el="read-more.container"]')
        .getAttribute('aria-expanded') === 'true'

    event.target
      .closest('[data-el="read-more.container"]')
      .setAttribute('aria-expanded', !currentState)
  }
}

customElements.define('read-more', ReadMore)
